// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { PreviouslyPurchasedFilters } from "@pace/App/Services/PreviouslyPurchasedService";

export const DispatchFilterUpdate: Handler<{ filters?: PreviouslyPurchasedFilters } & UpdateSearchFieldsType> =
    props => {
        const { type, filters = {} } = props.parameter as any;
        props.dispatch({
            type: "Pages/XPreviouslyPurchasedFilters/UpdateFilters",
            parameter: {
                /* if its replace then we can cleanup by send filters: {}, if its undefined|initialize we can change/override filters */
                type,
                previouslyPurchasedFilters: {
                    filters,
                },
            },
        } as any);
    };

export const chain = [DispatchFilterUpdate];

const updatePreviouslyPurchasedFilters = createHandlerChainRunner(chain, "UpdatePreviouslyPurchasedFilters");

export default updatePreviouslyPurchasedFilters;
